import { logRoutes } from './logs';
import { featureFlagRoutes } from './feature-flags';

export const accessRoutes = [
  {
    path: 'access',
    children: [...logRoutes, ...featureFlagRoutes],
  },
];
